module.exports = __webpack_public_path__ + "4571a12b04a8f71981eac9e48bc6bfba.jpg";